<ion-spinner class="size-full" [name]="name()"></ion-spinner>